var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function getUnifySelectInventoryActivityRequestCheckParams({
  joinDetailCheckTypes,
  checkProductChannel,
  checkBrand,
  checkCategory,
  regActivities,
  regActivityStocks,
  orgNo,
  marketRank,
  leave,
  repeatOrder,
  orderCategory,
  orderType,
  productType,
  activityType,
  commodityList
}, carrierDelivery, isPromotion, hotSaleActivity) {
  return {
    checkTypes: joinDetailCheckTypes.map(({ code }) => code).join(","),
    params: JSON.stringify({
      orgNo,
      productChannel: checkProductChannel,
      brand: checkBrand,
      category: checkCategory
    }),
    checkDatas: {
      activityInfo: null,
      regActivity: regActivities && Array.from(regActivities.entries()).map(([activityTypeId, { remainAmount: remainingAmount }]) => ({
        activityTypeId,
        remainingAmount,
        activityInventory: regActivityStocks.get(activityTypeId) || []
      })),
      orderInfo: [
        {
          orderParams: JSON.stringify(__spreadValues({
            hotSaleActivity: hotSaleActivity || false,
            orgNo,
            productChannel: checkProductChannel,
            brand: checkBrand,
            category: checkCategory,
            marketRank,
            leave,
            repeatOrder,
            orderCategory,
            orderType,
            productType,
            activityType
          }, isPromotion ? {} : {
            products: commodityList.map(({ quantity, no: unionCode, commodityId: productId, paramConfig, lineNo, packageId, packageSize }) => {
              const products = {
                productId,
                quantity,
                unionCode,
                extraFields: paramConfig ? JSON.stringify(paramConfig) : void 0,
                lineNo,
                packageId,
                packageSize
              };
              return products;
            })
          })),
          carrierDelivery,
          commodities: commodityList.map(({ packageSize, quantity, no: unionCode, commodityId: productId, paramConfig, lineNo, packageId }) => {
            const result = {
              productId,
              quantity,
              unionCode,
              extraFields: paramConfig ? JSON.stringify(paramConfig) : void 0,
              lineNo,
              packageId,
              packageSize
            };
            return result;
          })
        }
      ]
    }
  };
}
export { getUnifySelectInventoryActivityRequestCheckParams };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/business/unifySelectInventory/activity/getRequestCheckParams.js